<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <div class="stripe-configuration">
          <h2>{{ editMode ? 'Edit' : 'Create' }} Square Configuration</h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label v-if="field.name !== 'squareConfigurationId' || editMode" :for="field.name">{{ field.label }}:</label>

              <input v-if="(field.name !== 'active' && field.name !== 'status' && field.name !== 'squareConfigurationId' && field.name !== 'application' && field.name !== 'percentage') || (field.name === 'squareConfigurationId' && editMode)"
                     :id="field.name"
                     v-model="editedConfig[field.name]"
                     :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }"
                     type="text"
                     class="form-control responsive-input"
                     :disabled="(field.name === 'squareName' || field.name === 'squareConfigurationId') && editMode">

              <select v-else-if="field.name === 'application'" :id="field.name" v-model="editedConfig[field.name]" class="form-select" style="max-width: 500px;">
                <option v-for="app in applicationList" :key="app" :value="app">{{ app }}</option>
              </select>

              <input v-else-if="field.name === 'percentage'"
                     :id="field.name"
                     :value="editedConfig.percentage + '%'"
                     type="text"
                     class="form-control responsive-input"
                     style="min-width: 120px;"
                     disabled>

              <input class="checkbox" v-else-if="field.name === 'active' || field.name === 'status'"
                     type="checkbox"
                     :id="field.name"
                     v-model="editedConfig[field.name]"
                     disabled>
            </div>

            <p class="text-muted">
              Percentage, Active and Status are read-only here — they're managed on the
              <router-link :to="{ name: 'PaymentManagement' }">Payment Management</router-link> page and
              the backend ignores these fields when saving from this form.
            </p>

            <div v-if="error != ''" class="error-message">{{ error }}</div>
            <br>
            <a role="button" class="procricket-btn" @click="saveChanges">{{ editMode ? 'Save Changes' : 'Create Square Configuration' }}</a>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import { SquareConfig } from '@/model/models'
import AdminService from "@/services/admin-service";

export default defineComponent({
  name: 'Square Edit',
  components: {
    Header,
  },
  data() {
    return {
      editedConfig: {
        squareConfigurationId: this.$route.params.id,
        squareName: this.$route.params.squareName,
        accessToken: this.$route.params.accessToken,
        locationId: this.$route.params.locationId,
        webhookSignatureKey: this.$route.params.webhookSignatureKey,
        webhookUrl: this.$route.params.webhookUrl,
        redirectUrl: this.$route.params.redirectUrl,
        apiBase: this.$route.params.apiBase,
        application: this.$route.params.application,
        percentage: Number(this.$route.params.percentage) || 0,
        active: (this.$route.params.active === 'true'),
        status: (this.$route.params.status === 'true')
      },
      editMode: false,
      applicationList: [],
      fields: [
        { name: "squareConfigurationId", label: "Square Configuration Id" },
        { name: "squareName", label: "Square Name" },
        { name: "accessToken", label: "Access Token" },
        { name: "locationId", label: "Location Id" },
        { name: "webhookSignatureKey", label: "Webhook Signature Key" },
        { name: "webhookUrl", label: "Webhook URL" },
        { name: "redirectUrl", label: "Redirect URL" },
        { name: "apiBase", label: "API Base" },
        { name: "application", label: "Application" },
        { name: "percentage", label: "Percentage" },
        { name: "active", label: "Active" },
        { name: "status", label: "Status" }
      ],
      error: ""
    }
  },
  created() {
    if (this.$route.params.id) {
      this.editMode = true;
    }
    const storedApps = localStorage.getItem('applicationList');
    if (storedApps) {
      this.applicationList = JSON.parse(storedApps);
    } else {
      AdminService.getApplications().then(() => {
        this.applicationList = JSON.parse(localStorage.getItem('applicationList'));
      });
    }
  },
  methods: {
    saveChanges() {
      const dataToSave = new SquareConfig(
          this.editedConfig.squareConfigurationId,
          this.editedConfig.squareName,
          this.editedConfig.accessToken,
          this.editedConfig.locationId,
          this.editedConfig.webhookSignatureKey,
          this.editedConfig.webhookUrl,
          this.editedConfig.redirectUrl,
          this.editedConfig.apiBase,
          this.editedConfig.application,
          this.editedConfig.percentage,
          this.editedConfig.active,
          this.editedConfig.status
      );

      if (this.editMode) {
        AdminService.updateSquareConfiguration(dataToSave).then(() => {
          alert('Update complete');
          this.$router.push({ name: 'SquareConfig' });
        }).catch((error) => {
          console.error("Error updating Square configuration:", error);
          if (error.response && error.response.data && error.response.data.message) {
            alert(error.response.data.message);
          }
        });
      } else {
        AdminService.insertSquareConfiguration(dataToSave).then(() => {
          alert('Insert complete');
          this.$router.push({ name: 'SquareConfig' });
        }).catch((error) => {
          this.error = error.message;
        });
      }
    }
  }
})
</script>

<style src="../../assets/style.css">
</style>
